import type { HTMLAttributes } from 'react';
import { cn } from './lib/cn';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'circular' | 'rectangular' | 'card' | 'button';
}

const variantClasses = {
  text: 'h-4 rounded-md',
  circular: 'aspect-square rounded-full',
  rectangular: 'rounded-[14px]',
  card: 'min-h-36 rounded-[var(--radius-lg)] border border-[var(--border)]',
  button: 'h-11 rounded-[14px]',
};

export function Skeleton({
  className,
  variant = 'rectangular',
  'aria-hidden': ariaHidden = true,
  ...props
}: SkeletonProps) {
  return (
    <div
      aria-hidden={ariaHidden}
      className={cn(
        'animate-pulse bg-[var(--surface-raised)] motion-reduce:animate-none',
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  );
}
